import {Component, EventEmitter, Input, Output} from '@angular/core';
import {add, endOfWeek, format, startOfWeek, sub} from 'date-fns';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';

@Component({
  selector: 'app-week-slider',
  templateUrl: './week-slider.component.html',
  styleUrls: ['./week-slider.component.scss'],
  standalone: false
})
export class WeekSliderComponent {

  @Input() fromDate: string = '';
  @Output() fromDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Input() toDate: string = '';
  @Output() toDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Output() dateChange: EventEmitter<boolean> = new EventEmitter<boolean>;

  @Input() optionalData: string = '';

  get isToday(): boolean {
    return (format(startOfWeek(this.fromDate), 'dd-MM-yyyy') === format(startOfWeek(new Date()), 'dd-MM-yyyy'));
  }

  get valueTo(): string {
    return this.toDate || format(add(this.fromDate, {days: 7}), 'yyyy-MM-dd');
  }

  constructor(
    protected hapticsImpactManager: HapticsImpactManagerService
  ) {
  }


  /**
   * Ir a la siguiente semana
   *
   */
  addDays(days: number) {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(add(this.fromDate, {days: days}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Ir a la anterior semana
   *
   */
  subtractDays(days: number) {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(sub(this.fromDate, {days: days}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Hoy
   *
   */
  goToday() {
    this.hapticsImpactManager.hapticsImpactHeavy();

    this.fromDate = format(startOfWeek(new Date(), {weekStartsOn: 1}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Establecer fecha para filtrar
   *
   */
  setDateToFilter() {
    this.toDate = format(endOfWeek(this.fromDate, {weekStartsOn: 1}), 'yyyy-MM-dd');

    this.fromDateChange.emit(this.fromDate);
    this.toDateChange.emit(this.toDate);
    this.dateChange.emit(true);
  }

}
